import { Base } from "./base";

export class VehicleCheck extends Base {
    VehicleCheckID?: string;
    VehcileID?: string;
    AuthorID?: string;
    FineID?: string;
    Date?: Date;

    // Model properties
    ParkingID?: number;
    Latitude?: number;
    Longitude?: number;
    Owner?: string;
    Plate?: string;

    // Web properties
    IsSelected?: boolean = false;
}